import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { Button } from 'antd';
import { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';

import { formatNumberForAgCell, getUnitCellStyle } from 'src/utils/ag-grid-util';

import { SupplierInventoryRow } from 'src/atomic-components/templates/PageBoard/InventorySupplierInboundBoard/InventorySupplierInboundBoard';

const defaultColDef = {
  sortable: true,
  resizable: true,
  filter: true,
};

export interface SupplierInventoryTableRef {
  clearSelection: () => void;
}

interface SupplierInventoryTableProps {
  rowData: SupplierInventoryRow[];
  onSelectedRowsChange: (rows: SupplierInventoryRow[]) => void;
  clearItems: () => void;
}

const SupplierInventoryTable = forwardRef<SupplierInventoryTableRef, SupplierInventoryTableProps>(
  ({ rowData, onSelectedRowsChange, clearItems }, ref) => {
    const gridRef = useRef<AgGridReact>(null);

    useImperativeHandle(ref, () => ({
      clearSelection: () => {
        if (gridRef.current?.api) {
          gridRef.current.api.deselectAll();
        }
      },
    }));

    const columnDefs: ColDef<SupplierInventoryRow>[] = useMemo(
      () => [
        {
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 54,
          headerName: '',
          field: 'selection',
          suppressMenu: true,
          sortable: false,
          filter: false,
          resizable: false,
        },
        {
          headerName: 'id',
          field: 'inventoryId',
          hide: true,
        },
        {
          headerName: '재고명',
          field: 'inventoryName',
          width: 320,
          filter: 'agTextColumnFilter',
          floatingFilter: true,
        },
        {
          headerName: '단위',
          field: 'unit',
          width: 100,
          cellStyle: getUnitCellStyle,
        },
        {
          headerName: '재고',
          field: 'stock',
          valueFormatter: formatNumberForAgCell,
          type: 'numericColumn',
          width: 88,
        },
      ],
      []
    );

    return (
      <div className='ag-theme-alpine height100 flexColumn'>
        <div className='flexRow flexSpaceBetween'>
          <Button danger onClick={() => clearItems()}>
            입력 초기화
          </Button>
        </div>
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowSelection='multiple'
          onSelectionChanged={(e) => {
            onSelectedRowsChange(e.api.getSelectedRows());
          }}
          enableCellTextSelection={true}
        />
      </div>
    );
  }
);

SupplierInventoryTable.displayName = 'SupplierInventoryTable';

export default SupplierInventoryTable;
